<template>
  <br>

  <Navigation yvisina=15 @reload-parent="methodThatForcesUpdate">
    <template #atag>
      <a></a>
    </template>

    <template #content>


      <div style="padding-top: 80px;"></div>
      <div class="darken-image  image-container">

        <img src="../assets/sport.jpg" class="img-fluid darkenimg" style="">
<div class="text-overlay">
  <h2><span>{{ $t('sportnaslov') }}</span></h2>
</div>
</div>



      <section id="hero-animated" class="hero-animated d-flex align-items-center" style="min-height:15vh  !important;">
        <div class="container d-flex flex-column justify-content-center align-items-center text-center position-relative"
          data-aos="zoom-out">

          <p style="font-size: 16px;">{{ $t('x13') }}</p>

        </div>

      </section>


      <div class="container" style="padding:40px 20px;">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card bg-c-tenis order-card text-center">
              <div class="card-block" style="padding:30px;">
                <h4 style="color:#fff;">{{ $t('multi_bez_rez') }}</h4>
              </div>
            </div>
          </div>
        </div>
        <div style="height:200px;"></div>
      </div>


<!-- ======= Footer ======= -->
<footer id="footer" class="footer">

<div class="footer-content">
  <div class="container">
    <div class="row">

      <div class="col-lg-12 col-md-12">
        <div class="footer-info">
          <h3>Mon Perin</h3>
          <p>

        <p>Mon Perin d.d. Trg La Musa 2 HR-52211 Bale, Croatia</p><br>
        <p>Oib: 06374155285</p><br>


            <strong>Reservations & Info:</strong> +385 98 961 9668<br>
            <strong>Reception:</strong> +385 98 961 9668<br>
            <strong>Email:</strong> info@monperin.hr<br>
          </p>
        </div>
      </div>

      <div class="col-lg-4 col-md-12 footer-newsletter"></div>

    </div>
  </div>
</div>


</footer><!-- End Footer -->


    </template>


  </Navigation>


</template>

<style scoped>
.hero-animated {
  padding: 50px 0 0px;
  min-height: 30vh;
}

section {
  padding: 0px 0;

}

.hero-animated p {
  color: rgba(var(--color-secondary-rgb), .8);
  margin: 0 0 30px 0;
  font-size: 20px;
  font-weight: 400;
}

@media (max-width: 640px) {
  .hero-animated p {
    font-size: 18px;
    margin-bottom: 30px;
  }
}
</style>

<script>

import Navigation from '../components/Navigation.vue'
export default {
  name: 'Info',
  components: {
    Navigation
  },

  data() {
    return {
      prijava: false,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.prijava = this.$store.getters.isAuth;
    $("#preloader").hide();
  },

  methods: {
    methodThatForcesUpdate() {},
  }
}
</script>
